// Version : 0.0.1
// Author : SATHISH
// LastEdit : SHIYAM
// MODFIED DATE: 26-09-2025
// Last ADD : Removed excel related code and added command lines

const PreCloseReportActionTypes = {
	/************** GET PRECLOSE REPORT LIST START ************************** */
	GET_PRECLOSE_REPORT_LIST_START: 'get_preclose_report_start',
	GET_PRECLOSE_REPORT_LIST_SUCCESS: 'get_preclose_report_success',
	GET_PRECLOSE_REPORT_LIST_FAILURE: 'get_preclose_report_failure',
	GET_PRECLOSE_REPORT_LIST_RESPONSE_RESET: 'get_preclose_report_response_reset',
	GET_PRECLOSE_REPORT_LIST_RESPONSE_CHANGED: 'get_preclose_report_response_changed',
	/************** GET PRECLOSE REPORT LIST END ************************** */
};
export default PreCloseReportActionTypes;
